import React, { memo } from "react";
import * as PropTypes from "prop-types";
import { formatValue } from "../../../utilities";
import GniGroupBySectorChart from "../charts/GniGroupBySectorChart";

const ShareOfUsersChart = props => (
  <GniGroupBySectorChart
    ref={props.innerRef}
    data={props.data}
    reversedStacks={true}
    tooltipFormatter={function() {
      return `${this.series.name} Share of ${
        this.key
      } Users: <strong>${formatValue(this.percentage / 100, true)}</strong>`;
    }}
  />
);

ShareOfUsersChart.propTypes = {
  data: PropTypes.array.isRequired
};

export default memo(
  React.forwardRef((props, ref) => (
    <ShareOfUsersChart innerRef={ref} {...props} />
  ))
);
